import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import CustomersModule from "./modules/customers/customers";
import Dialog from "./modules/dialog";
import FormModule from "./modules/encoding/form";
import ModalModule from "./modules/encoding/modal";
import MyClassifiedsModule from "./modules/myImmoweb/classified";
import OrdersModule from "./modules/orders/orders";
import PicturesModule from "./modules/encoding/pictures";
import StepsWizard from "./modules/progression/steps-wizard";
import ResetWizardModule from "./modules/modal/reset-wizard";
import Time from "./modules/time";
import UserModule from "./modules/user/user";
import AgreementModule  from "./modules/orders/agreement";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
    key: "iwb-encoding",
    storage: localStorage,
    modules: ["OrdersModule"]
});

export default new Vuex.Store({
    modules: {
        CustomersModule: CustomersModule,
        Dialog: Dialog,
        FormModule: FormModule,
        ModalModule: ModalModule,
        MyClassifiedsModule: MyClassifiedsModule,
        OrdersModule: OrdersModule,
        PicturesModule: PicturesModule,
        ResetWizardModule: ResetWizardModule,
        Time: Time,
        UserModule: UserModule,
        StepsWizard: StepsWizard,
        AgreementModule: AgreementModule,
    },
    plugins: [vuexPersist.plugin],
});
